import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getToolLandingConfig } from '../lib/toolLandingConfigs';
import ToolSeoHead from '../components/seo/ToolSeoHead';
import ToolLandingSections from '../components/seo/ToolLandingSections';
import PerfectForSection from '../components/seo/PerfectForSection';
import ToolPageLabel from '../components/seo/ToolPageLabel';
import TemplateSelectorPanel from '../components/tools/TemplateSelectorPanel';
import ProposalCategoryPanel from '../components/tools/ProposalCategoryPanel';
import { PublicToolHeader } from '../components/PublicToolHeader';

export default function DocumentToolLandingPage() {
  const { serviceType } = useParams();
  const config = getToolLandingConfig(serviceType);

  if (!config || config.isUtility) {
    return <Navigate to="/" replace />;
  }

  const isProposalBuilder = serviceType === 'business-proposal-builder';

  return (
    <div className="min-h-screen bg-muted/20">
      <ToolSeoHead
        title={config.titleTag}
        description={config.metaDescription}
        canonicalPath={config.canonicalPath}
      />
      <PublicToolHeader backTo="/" />

      <main className="max-w-6xl mx-auto p-6 lg:p-10 space-y-10">
        <section className="max-w-3xl space-y-4">
          <ToolPageLabel label={config.pageLabel} exploreAction="generate" />
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground leading-tight">
            {config.heroHeadline}
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl">{config.heroSubtext}</p>
          <p className="sr-only">{config.keywords?.join(', ')}</p>
        </section>

        <section className="pt-6 border-t border-border">
          {isProposalBuilder ? (
            <ProposalCategoryPanel />
          ) : (
            <TemplateSelectorPanel
              documentType={config.documentType}
              embedded
            />
          )}
        </section>

        <div className="pt-6 border-t border-border space-y-10 max-w-4xl">
          <PerfectForSection items={config.perfectFor} />
          <ToolLandingSections config={config} />
        </div>
      </main>
    </div>
  );
}
